import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessOverviewPage {
  accessOverview: boolean;
  accessFilter: AccessReportsWizardOption;
  excludedColor: AccessReportsWizardOption;
  id: number;
  graphMiles: string;
  providerFive: AccessReportsWizardOption;
  providerFiveColor: AccessReportsWizardOption;
  providerFour: AccessReportsWizardOption;
  providerFourColor: AccessReportsWizardOption;
  providerOne: AccessReportsWizardOption;
  providerOneColor: AccessReportsWizardOption;
  providerThree: AccessReportsWizardOption;
  providerThreeColor: AccessReportsWizardOption;
  providerTwo: AccessReportsWizardOption;
  providerTwoColor: AccessReportsWizardOption;
  showMaximums: boolean;
  showMinimums: boolean;
  withColor: AccessReportsWizardOption;
  withoutColor: AccessReportsWizardOption;

  constructor(accessOverview: boolean, id: number) {
    this.accessFilter = null;
    this.accessOverview = accessOverview;
    this.excludedColor = null;
    this.graphMiles = null;
    this.id = id;
    this.providerFive = null;
    this.providerFiveColor = null;
    this.providerFour = null;
    this.providerFourColor = null;
    this.providerOne = null;
    this.providerOneColor = null;
    this.providerThree = null;
    this.providerThreeColor = null;
    this.providerTwo = null;
    this.providerTwoColor = null;
    this.showMaximums = false;
    this.showMinimums = false;
    this.withColor = null;
    this.withoutColor = null;
  }
}

export { AccessOverviewPage };
